import { useContext, useState, useEffect } from "react";
import { cargaProveedores, createProveedor } from "../services/proveedores.jsx";
import { cargaAllMedida, cargaMedidaTipos, createMedida } from "../services/medida.jsx";
import {
  cargaAllProductos,
  createProducto,
  cargarTipoProducto,
} from "../services/productos.jsx";
import { cargaAllMarcas, createMarca } from "../services/marca.jsx";
import { createProductoProveedor } from "../services/productoProveedor.jsx";
import {
  formValidatorProveedor,
  formValidatorProducto,
  formValidatorPP,
} from "../helpers/validador.jsx";
import Select from "react-select";
import Context from "../context/UserContext";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

export default function Navbar({ setActualizar, setActualizarProveedor }) {
  const navigate = useNavigate();
  const { usuario, logout } = useContext(Context);
  const [proveedores, setProveedores] = useState([]);
  const [marcas, setMarcas] = useState([]);
  const [tipoProducto, setTipoProducto] = useState([]);
  const [medidas, setMedidas] = useState([]);
  const [productos, setProductos] = useState([]);
  const [errores, setErrores] = useState([]);
  const [selectedOptionMarca, setSelectedOptionMarca] = useState([]);
  const [selectedOptionMedida, setSelectedOptionMedida] = useState([]);
  const [selectedOptionTp, setSelectedOptionTp] = useState([]);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeModal, setActiveModal] = useState(null);

  const [formulario, setFormulario] = useState({ proveedor: "", producto: "" });
  const [formularioProducto, setFormularioProducto] = useState({
    codigo_barra: "", nombreProducto: "", marca: "", tipoProducto: "", foto: null, medida: "",
  });
  const [formularioProveedor, setFormularioProveedor] = useState({
    rutProveedor: "", nombreProveedor: "", correoProveedor: "", telefonoProveedor: "",
  });
  const [nombreMarca, setNombreMarca] = useState("");
  const [formularioMedida, setFormularioMedida] = useState({ numero: "", medidaTipo: "" });
  const [medidaTipos, setMedidaTipos] = useState([]);

  useEffect(() => {
    cargaProveedores()
      .then((p) => {
        const options = p.map(({ id, nombre }) => ({ value: id, label: nombre }));
        setProveedores(options);
      })
      .catch((error) => console.error(error));
    cargaAllProductos()
      .then((p) => {
        const options = p.map(({ id, nombre }) => ({ value: id, label: nombre }));
        setProductos(options);
      })
      .catch((error) => console.error(error));
    cargaAllMarcas()
      .then((m) => {
        const options = m.map(({ id, nombre }) => ({ value: id, label: nombre }));
        setMarcas(options);
      })
      .catch((error) => console.error(error));
    cargarTipoProducto()
      .then((t) => {
        const options = t.map(({ id, nombre }) => ({ value: id, label: nombre }));
        setTipoProducto(options);
      })
      .catch((error) => console.error(error));
    cargaAllMedida()
      .then((m) => {
        const options = m.map(({ id, numeracion, nombre }) => ({
          value: id,
          label: numeracion + " " + nombre,
        }));
        setMedidas(options);
      })
      .catch((error) => console.error(error));
    cargaMedidaTipos()
      .then((t) => {
        const options = t.map(({ id, nombre }) => ({ value: id, label: nombre }));
        setMedidaTipos(options);
      })
      .catch((error) => console.error(error));
  }, []);

  const handleBlurProveedor = (e) => {
    const { name, value } = e.target;
    const errorMessage = formValidatorProveedor(name, value);
    let copia = [...errores];
    let estado = false;
    for (let i = 0; i < copia.length; i++) {
      const element = copia[i];
      if (element[0] === errorMessage[0]) {
        estado = true;
        if (errorMessage[1] != null) {
          element[1] = errorMessage[1];
        } else {
          copia.splice(i, 1);
          i--;
        }
      }
    }
    if (!estado && errorMessage[1] != null) {
      copia.push([errorMessage[0], errorMessage[1]]);
    }
    setErrores(copia);
  };

  const handleSubmit = () => {
    const msjError = formValidatorPP(formulario);
    if (msjError.length === 0) {
      createProductoProveedor(formulario).then((res) => {
        if (res.success) {
          Swal.fire({
            title: "Exito",
            text: "Se Ha Creado la Relacion Producto Proveedor!",
            icon: "success",
            confirmButtonText: "Ok!",
            didClose: () => setActualizar(true),
          });
        } else {
          Swal.fire({ title: "Error!", text: res.message, icon: "error", confirmButtonText: "Ok!" });
        }
      });
    } else {
      Swal.fire({ title: "Error!", html: msjError, icon: "error", confirmButtonText: "Ok!" });
    }
  };

  const handleSubmitFormProd = () => {
    const msjError = formValidatorProducto(formularioProducto);
    if (msjError.length === 0) {
      createProducto(formularioProducto).then((res) => {
        if (res.success) {
          cargaAllProductos()
            .then((producto) => {
              const options = producto.map(({ id, nombre }) => ({ value: id, label: nombre }));
              setProductos(options);
              Swal.fire({
                title: "Exito",
                text: "Se Ha Creado el Producto Con Exito!",
                icon: "success",
                confirmButtonText: "Ok!",
              }).then(() => {
                setFormularioProducto({ codigo_barra: "", nombreProducto: "", marca: "", tipoProducto: "", foto: null, medida: "" });
                setSelectedOptionMarca([]);
                setSelectedOptionMedida([]);
                setSelectedOptionTp([]);
                setActiveModal(null);
              });
            })
            .catch((error) => console.error(error));
        } else {
          Swal.fire({ title: "Error!", text: res.message, icon: "error", confirmButtonText: "Ok!" });
        }
      });
    } else {
      Swal.fire({ title: "Error!", html: msjError, icon: "error", confirmButtonText: "Ok!" });
    }
  };

  const handleSubmitFormProveedor = () => {
    if (!formularioProveedor.nombreProveedor.trim()) {
      Swal.fire({ title: "Error!", text: "Debes ingresar el nombre del proveedor", icon: "error", confirmButtonText: "Ok!" });
      return;
    }
    createProveedor(formularioProveedor).then((res) => {
      if (res.success) {
        Swal.fire({
          title: "Exito",
          text: "Se Ha Creado el Proveedor Con Exito!",
          icon: "success",
          confirmButtonText: "Ok!",
        }).then(() => {
          cargaProveedores()
            .then((proveedores) => {
              const options = proveedores.map(({ id, nombre }) => ({ value: id, label: nombre }));
              setProveedores(options);
            })
            .catch((error) => console.error(error));
          setActualizarProveedor(true);
          setFormularioProveedor({ rutProveedor: "", nombreProveedor: "", correoProveedor: "", telefonoProveedor: "" });
          setActiveModal(null);
        });
      } else {
        Swal.fire({ title: "Error!", text: res.message, icon: "error", confirmButtonText: "Ok!" });
      }
    });
  };

  const handleSelectChange = (item, id) => {
    const { value } = item;
    setFormulario((prev) => ({ ...prev, [id]: value }));
  };

  const handleChange = (event) => {
    const { name, value, files } = event.target;
    setFormularioProducto((prev) => ({ ...prev, [name]: name === "foto" ? files[0] : value }));
  };

  const handleChangeProveedor = (event) => {
    const { name, value } = event.target;
    setFormularioProveedor((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmitMarca = () => {
    if (!nombreMarca.trim()) {
      Swal.fire({ title: "Error!", text: "Debes ingresar un nombre de marca", icon: "error", confirmButtonText: "Ok!" });
      return;
    }
    createMarca(nombreMarca.trim()).then((res) => {
      if (res.success) {
        cargaAllMarcas().then((m) => {
          setMarcas(m.map(({ id, nombre }) => ({ value: id, label: nombre })));
        });
        Swal.fire({ title: "Exito", text: "Marca creada con exito!", icon: "success", confirmButtonText: "Ok!" })
          .then(() => { setNombreMarca(""); setActiveModal(null); });
      } else {
        Swal.fire({ title: "Error!", text: res.message, icon: "error", confirmButtonText: "Ok!" });
      }
    });
  };

  const handleSubmitMedida = () => {
    if (!formularioMedida.numero || !formularioMedida.medidaTipo) {
      Swal.fire({ title: "Error!", text: "Debes completar ambos campos", icon: "error", confirmButtonText: "Ok!" });
      return;
    }
    createMedida(formularioMedida.numero, formularioMedida.medidaTipo).then((res) => {
      if (res.success) {
        cargaAllMedida().then((m) => {
          setMedidas(m.map(({ id, numeracion, nombre }) => ({ value: id, label: numeracion + " " + nombre })));
        });
        Swal.fire({ title: "Exito", text: "Unidad de medida creada con exito!", icon: "success", confirmButtonText: "Ok!" })
          .then(() => { setFormularioMedida({ numero: "", medidaTipo: "" }); setActiveModal(null); });
      } else {
        Swal.fire({ title: "Error!", text: res.message, icon: "error", confirmButtonText: "Ok!" });
      }
    });
  };

  const navLinks = [
    { label: "Rolear P.P.", modal: "modalRolear" },
    { label: "Crear Producto", modal: "modalProducto" },
    { label: "Crear Proveedor", modal: "modalProveedor" },
    { label: "Crear Marca", modal: "modalMarca" },
    { label: "Crear Medida", modal: "modalMedida" },
  ];

  return (
    <>
      <nav className="bg-gradient-to-r from-pons-500 via-pons-600 to-pons-500 shadow-nav sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center gap-3">
              <a href="/home">
                <img src="logo-pons.png" alt="Logo" className="h-10" />
              </a>
            </div>

            <div className="hidden md:flex items-center gap-1">
              {navLinks.map((link) => (
                <button
                  key={link.modal}
                  onClick={() => setActiveModal(link.modal)}
                  className="text-white/90 hover:text-pons-300 hover:bg-white/10 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200"
                >
                  {link.label}
                </button>
              ))}
              <button
                onClick={() => navigate("/excel")}
                className="text-white/90 hover:text-pons-300 hover:bg-white/10 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200"
              >
                Ver Compras
              </button>
              <button
                onClick={() => logout()}
                className="text-white/90 hover:text-red-300 hover:bg-white/10 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200"
              >
                Cerrar Sesion
              </button>
            </div>

            <div className="flex items-center gap-3">
              <button
                onClick={() => {
                  const sidebar = document.getElementById("offcanvasRight");
                  if (sidebar) sidebar.classList.remove("translate-x-full");
                }}
                className="relative text-white hover:bg-white/10 p-2 rounded-xl transition-all duration-200"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 100 4 2 2 0 000-4z" />
                </svg>
              </button>

              <span className="hidden sm:block text-white/80 text-sm font-medium">
                {usuario}
              </span>

              <button
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                className="md:hidden text-white hover:bg-white/10 p-2 rounded-lg"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              </button>
            </div>
          </div>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden bg-pons-700/50 border-t border-white/10 px-4 py-3 space-y-1">
            {navLinks.map((link) => (
              <button
                key={link.modal}
                onClick={() => { setActiveModal(link.modal); setMobileMenuOpen(false); }}
                className="block w-full text-left text-white/90 hover:text-pons-300 hover:bg-white/10 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200"
              >
                {link.label}
              </button>
            ))}
            <button
              onClick={() => { navigate("/excel"); setMobileMenuOpen(false); }}
              className="block w-full text-left text-white/90 hover:text-pons-300 hover:bg-white/10 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200"
            >
              Ver Compras
            </button>
            <button
              onClick={() => logout()}
              className="block w-full text-left text-white/90 hover:text-red-300 hover:bg-white/10 px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200"
            >
              Cerrar Sesion
            </button>
          </div>
        )}
      </nav>

      {activeModal === "modalRolear" && (
        <Modal onClose={() => setActiveModal(null)} title="Agregar Productos a Proveedor">
          <div className="space-y-4">
            <div>
              <label className="label-field">Seleccione el Proveedor:</label>
              <Select options={proveedores} className="basic-single" classNamePrefix="select" onChange={(item) => handleSelectChange(item, "proveedor")} />
            </div>
            <div>
              <label className="label-field">Seleccione el Producto:</label>
              <Select options={productos} className="basic-single" classNamePrefix="select" onChange={(item) => handleSelectChange(item, "producto")} />
            </div>
          </div>
          <ModalFooter onClose={() => setActiveModal(null)} onConfirm={handleSubmit} confirmText="Registrar" />
        </Modal>
      )}

      {activeModal === "modalProducto" && (
        <Modal onClose={() => setActiveModal(null)} title="Crear Producto">
          <div className="space-y-4">
            <div>
              <label className="label-field">Nombre del Producto</label>
              <input type="text" className="input-field" name="nombreProducto" placeholder="Nombre sin unidad de medida" onChange={handleChange} value={formularioProducto.nombreProducto} />
              <small className="text-danger text-xs">No agregar unidad de medida en este campo</small>
            </div>
            <div>
              <label className="label-field">Unidad de Medida</label>
              <Select options={medidas} className="basic-single" classNamePrefix="select" value={selectedOptionMedida} onChange={(item) => { setSelectedOptionMedida(item); setFormularioProducto((prev) => ({ ...prev, medida: item.value })); }} />
            </div>
            <div>
              <label className="label-field">Codigo de Barra</label>
              <input type="text" className="input-field" name="codigo_barra" placeholder="Opcional" onChange={handleChange} value={formularioProducto.codigo_barra} />
            </div>
            <div>
              <label className="label-field">Marca</label>
              <Select options={marcas} className="basic-single" classNamePrefix="select" value={selectedOptionMarca} onChange={(item) => { setSelectedOptionMarca(item); setFormularioProducto((prev) => ({ ...prev, marca: item.value })); }} />
            </div>
            <div>
              <label className="label-field">Tipo de Producto</label>
              <Select options={tipoProducto} className="basic-single" classNamePrefix="select" value={selectedOptionTp} onChange={(item) => { setSelectedOptionTp(item); setFormularioProducto((prev) => ({ ...prev, tipoProducto: item.value })); }} />
            </div>
            <div>
              <label className="label-field">Foto del Producto</label>
              <input type="file" className="input-field file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:bg-pons-200 file:text-pons-800 file:font-semibold hover:file:bg-pons-300 file:cursor-pointer" name="foto" accept="image/*" onChange={handleChange} />
            </div>
          </div>
          <ModalFooter onClose={() => setActiveModal(null)} onConfirm={handleSubmitFormProd} confirmText="Registrar" />
        </Modal>
      )}

      {activeModal === "modalProveedor" && (
        <Modal onClose={() => setActiveModal(null)} title="Crear Proveedor">
          <div className="space-y-4">
            <div>
              <label className="label-field">Nombre del Proveedor:</label>
              <input type="text" className="input-field" name="nombreProveedor" placeholder="Nombre" onBlur={handleBlurProveedor} onChange={handleChangeProveedor} value={formularioProveedor.nombreProveedor} />
            </div>
            <div>
              <label className="label-field">Rut del Proveedor <span className="text-ink-light text-xs font-normal">(Opcional)</span>:</label>
              <input type="text" className="input-field" name="rutProveedor" placeholder="XX.XXX.XXX-X" onBlur={handleBlurProveedor} onChange={handleChangeProveedor} value={formularioProveedor.rutProveedor} />
            </div>
            <div>
              <label className="label-field">Telefono del Proveedor <span className="text-ink-light text-xs font-normal">(Opcional)</span>:</label>
              <div className="flex">
                <span className="inline-flex items-center px-3 rounded-l-xl border border-r-0 border-surface-border bg-surface-muted text-ink-muted text-sm font-medium">
                  +56
                </span>
                <input type="text" className="input-field rounded-l-none" name="telefonoProveedor" placeholder="9XXXXXXXX" onBlur={handleBlurProveedor} onChange={handleChangeProveedor} value={formularioProveedor.telefonoProveedor} />
              </div>
            </div>
            <div>
              <label className="label-field">Correo del Proveedor <span className="text-ink-light text-xs font-normal">(Opcional)</span>:</label>
              <input type="text" className="input-field" name="correoProveedor" placeholder="correo@ejemplo.com" onBlur={handleBlurProveedor} onChange={handleChangeProveedor} value={formularioProveedor.correoProveedor} />
            </div>
          </div>
          {errores.length > 0 && (
            <div className="mt-3 bg-danger/10 border border-danger/30 rounded-xl p-3">
              {errores.map((element, index) => (
                <p key={index} className="text-danger text-sm text-center font-semibold">
                  {element[1]}
                </p>
              ))}
            </div>
          )}
          <ModalFooter onClose={() => setActiveModal(null)} onConfirm={handleSubmitFormProveedor} confirmText="Registrar" />
        </Modal>
      )}

      {activeModal === "modalMarca" && (
        <Modal onClose={() => setActiveModal(null)} title="Crear Marca">
          <div className="space-y-4">
            <div>
              <label className="label-field">Nombre de la Marca:</label>
              <input
                type="text"
                className="input-field"
                placeholder="Ej: Master Dog, Josera, etc."
                value={nombreMarca}
                onChange={(e) => setNombreMarca(e.target.value)}
              />
            </div>
          </div>
          <ModalFooter onClose={() => setActiveModal(null)} onConfirm={handleSubmitMarca} confirmText="Crear Marca" />
        </Modal>
      )}

      {activeModal === "modalMedida" && (
        <Modal onClose={() => setActiveModal(null)} title="Crear Unidad de Medida">
          <div className="space-y-4">
            <div>
              <label className="label-field">Numero (numeracion):</label>
              <input
                type="number"
                className="input-field"
                placeholder="Ej: 500, 1, 2.5"
                value={formularioMedida.numero}
                onChange={(e) => setFormularioMedida((prev) => ({ ...prev, numero: e.target.value }))}
              />
            </div>
            <div>
              <label className="label-field">Tipo de Medida:</label>
              <select
                className="select-field"
                value={formularioMedida.medidaTipo}
                onChange={(e) => setFormularioMedida((prev) => ({ ...prev, medidaTipo: e.target.value }))}
              >
                <option value="">Seleccione un tipo...</option>
                {medidaTipos.map((t) => (
                  <option key={t.value} value={t.value}>{t.label}</option>
                ))}
              </select>
            </div>
            <p className="text-xs text-ink-muted">
              Ejemplo:Numero <b>500</b> + Tipo <b>ml</b> = <b>500 ml</b>
            </p>
          </div>
          <ModalFooter onClose={() => setActiveModal(null)} onConfirm={handleSubmitMedida} confirmText="Crear Medida" />
        </Modal>
      )}
    </>
  );
}

function Modal({ children, onClose, title }) {
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = ""; };
  }, []);

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-surface-card rounded-2xl shadow-card-lg w-full max-w-xl mx-4 animate-fade-in max-h-[95vh] flex flex-col">
        <div className="flex items-center justify-between p-5 border-b border-surface-border flex-shrink-0">
          <h2 className="text-lg font-bold text-ink">{title}</h2>
          <button onClick={onClose} className="text-ink-muted hover:text-ink p-1 rounded-lg hover:bg-surface-muted transition-colors">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="p-5 overflow-y-auto flex-1">{children}</div>
      </div>
    </div>
  );
}

function ModalFooter({ onClose, onConfirm, confirmText = "Confirmar" }) {
  return (
    <div className="flex gap-3 mt-6 pt-4 border-t border-surface-border flex-shrink-0">
      <button onClick={onClose} className="btn-secondary flex-1">Cerrar</button>
      <button onClick={onConfirm} className="btn-success flex-1">{confirmText}</button>
    </div>
  );
}
